import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConstantService {
  //Authentication
  API_URL: string = environment.API_URL;
  LOGIN: string = 'auth/customerLogin';
  LOGOUT: string = 'logout';
  FORGETPASSWORD = 'auth/customerForgetPassword';
  RESETPASSWORD = 'auth/customerResetPassword';
  AUTH = 'auth';
  PARTNERS = 'partners';
  CUSTOMERS = 'customers';
  LOANS = 'loans';
  APPLICATION = 'application';
  LOANAPPLICANT = 'loanApplication';
  BITLY = 'anonymous';
  TINYURL = 'tinyurl';
  NOTIFICATION = 'notifications';
  PINCODE = 'pincode';
  BRANCHES = 'branches';
  LEAD = 'lead';
  SELFASSISTED = 'selfassisted';
  SYNCBCPARTNER = 'syncbcpartner';

  constructor() {
  }

  getUrl(path: string, params: Array<any> = []) {
    return !params.length ? [this.API_URL, path].join('') : [[this.API_URL, path].join(''), params.join('/')].join('/');
  }

  getUrlByQuery(path: string, query: Array<Object>) {
    let url = [this.API_URL, path].join('');
    let queryString = query.map((o: any) => {
      return `${o.name}=${o.value}`;
    }).join('&');
    return [url, queryString].join('?');
  }
}
